import React from 'react';
import { connect } from 'react-redux';
import { getPanels } from '_helpers';
import { PatientCareCenterNoteSpecTestSection } from './Section';
import { renderRLHeader } from './Helpers';
import { PatientCareCenterNoteObjectiveSpecTestsPanel } from './SpecTestsPanel';

class SpecTestsFullThicknessRotatorCuffTearCluster extends React.Component {

    render() {
        if (this.props.panels.length > 0) {
            return (
                <PatientCareCenterNoteSpecTestSection id='obj_spec_tests_FullThicknessRotatorCuffTearCluster' name='Full Thickness Rotator Cuff Tear Cluster' visible={false} flagged={this.props.flagged}>
                    {renderRLHeader()}
                    {
                        Object.keys(this.props.panels)
                            .map(key => {
                                return (<PatientCareCenterNoteObjectiveSpecTestsPanel key={this.props.panels[key].MOPNO} panelId={this.props.panels[key].MOPNO} includeFlags={false} header='Full Thickness Rotator Cuff Tear Cluster' />);
                            })
                    }
                </PatientCareCenterNoteSpecTestSection>
            );
        } else {
            return (
                <span />
            )
        }
    }
}

function mapStateToProps(state) {
    let noteId = state.ui.patientTabs[state.ui.patientCenter[state.ui.patients.selectedPtno].selectedTab].noteId;
    let noteType = parseInt(noteId.split("_")[0]);
    let pk = parseInt(noteId.split("_")[1]);
    let tsno = parseInt(Object.keys(state.entities.notes.PTOBJECTIVESPECTESTS)
        .find(key => (state.entities.notes.PTOBJECTIVESPECTESTS[key].TSEVNO === pk && noteType === 1)
            || (state.entities.notes.PTOBJECTIVESPECTESTS[key].TSNTNO === pk && noteType !== 1)));

    let flagCount = 0;
    if (state.entities.notes.PTOBJECTIVESPECTESTS[tsno].TSFULLDROPARMR === 'positive' ||
        state.entities.notes.PTOBJECTIVESPECTESTS[tsno].TSFULLDROPARML === 'positive') {
        flagCount++;
    }
    if (state.entities.notes.PTOBJECTIVESPECTESTS[tsno].TSFULLPAINFULARCR === 'positive' ||
        state.entities.notes.PTOBJECTIVESPECTESTS[tsno].TSFULLPAINFULARCL === 'positive') {
        flagCount++;
    }
    if (state.entities.notes.PTOBJECTIVESPECTESTS[tsno].TSFULLINFRASPINATUSR === 'positive' ||
        state.entities.notes.PTOBJECTIVESPECTESTS[tsno].TSFULLINFRASPINATUSL === 'positive') {
        flagCount++;
    }

    return {
        noteId: noteId,
        tsno: tsno,
        panels: getPanels(noteId, 'SpecialTest', 'FullThicknessRotatorCuffTearCluster'),
        flagged: flagCount >= 2 ? true : false
    };
}

const connectedSpecTestsFullThicknessRotatorCuffTearCluster = connect(mapStateToProps)(SpecTestsFullThicknessRotatorCuffTearCluster);
export { connectedSpecTestsFullThicknessRotatorCuffTearCluster as SpecTestsFullThicknessRotatorCuffTearCluster };



